// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../index';

import { gql } from 'graphql-tag';
import { MoneyFragmentDoc } from '../../../fragments/money.fragment.generated';
import { StoneShapeFragmentDoc } from './stoneShape.fragment.generated';
import { StoneColorFragmentDoc } from '../../gems/fragments/StoneColor.fragment.generated';
import { StoneClarityFragmentDoc } from '../../gems/fragments/stoneClarity.fragment.generated';
import { NonSkuLabGrownStoneImageFragmentDoc } from '../../../../../domain/stone/useStoneImage.generated';
export const NonSkuLabGrownFragmentDoc = gql`
    fragment nonSkuLabGrown on NonSkuLabGrown {
  __typename
  id
  salePrice(currency: $currency, region: $region) {
    ...money
  }
  shape {
    ...stoneShape
  }
  caratWeight
  color {
    ...stoneColor
  }
  clarity {
    ...stoneClarity
  }
  ...nonSkuLabGrownStoneImage
}
    ${MoneyFragmentDoc}
${StoneShapeFragmentDoc}
${StoneColorFragmentDoc}
${StoneClarityFragmentDoc}
${NonSkuLabGrownStoneImageFragmentDoc}`;